import React from 'react'
import style from './Header.css'

export const Header = ({ isShowPendingStores, isShowResultUpdate, showPendingStores, showResultUpdate, showModalPasteStock}) => (
    <div className={`page-header ${style.Header_pageHeader}`}>
        <div className="col-md-9">
            <h2>Stock de locales <small>actualización</small></h2>
        </div>
        <ul className={`nav nav-pills ${style.Header_navPills}`}>
            <li role="presentation" className={isShowPendingStores? 'active' : ''}><a onClick={showPendingStores}>Pendientes</a></li>
            <li role="presentation" className={isShowResultUpdate? 'active': ''}><a onClick={showResultUpdate}>Resultado</a></li>
            <li role="presentation"><a className="btn btn-md btn-info" onClick={showModalPasteStock}>Actualizar</a></li>
        </ul>
    </div>
);


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/components/Header.jsx